import React, { useRef, useEffect, useState } from "react";
import "./App.css";

// Три локальных видео (положите их в /src/)
import video1 from "./video1.MP4";
import video2 from "./video2.MP4";
import video3 from "./video3.MP4";

/**
 * Анимированный фон (звёзды + "shooting stars").
 */
const ParticleCanvas = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    let width = (canvas.width = window.innerWidth);
    let height = (canvas.height = window.innerHeight);
    canvas.style.background = "transparent";

    // Массив "обычных" звёзд
    const particleCount = 150;
    const particles = [];
    for (let i = 0; i < particleCount; i++) {
      particles.push({
        x: Math.random() * width,
        y: Math.random() * height,
        size: Math.random() * 2 + 0.5,
        speedX: (Math.random() - 0.5) * 0.3,
        speedY: (Math.random() - 0.5) * 0.3,
        opacity: Math.random() * 0.5 + 0.4,
      });
    }

    // "Падающие" звёзды
    const shootingStarsCount = 3;
    const shootingStars = [];
    for (let i = 0; i < shootingStarsCount; i++) {
      shootingStars.push({
        x: Math.random() * width * 0.3,
        y: Math.random() * height * 0.3,
        length: Math.random() * 70 + 40,
        speed: Math.random() * 2 + 2,
        size: 2,
        opacity: Math.random() * 0.5 + 0.5,
      });
    }

    let animationFrameId;
    const animate = () => {
      ctx.clearRect(0, 0, width, height);

      // Обычные звёзды
      particles.forEach((p) => {
        p.x += p.speedX;
        p.y += p.speedY;

        if (p.x < 0) p.x = width;
        if (p.x > width) p.x = 0;
        if (p.y < 0) p.y = height;
        if (p.y > height) p.y = 0;

        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size, 0, 2 * Math.PI);
        ctx.fillStyle = `rgba(255,255,255,${p.opacity})`;
        ctx.fill();
      });

      // Падающие звёзды
      shootingStars.forEach((star) => {
        star.x += star.speed;
        star.y += star.speed * 0.5;
        ctx.beginPath();
        ctx.moveTo(star.x, star.y);
        ctx.lineTo(star.x - star.length, star.y - star.length * 0.5);
        ctx.lineWidth = star.size;
        ctx.strokeStyle = `rgba(255,255,255,${star.opacity})`;
        ctx.stroke();

        if (star.x > width + star.length || star.y > height + star.length) {
          star.x = Math.random() * width * 0.3;
          star.y = Math.random() * height * 0.3;
        }
      });

      animationFrameId = requestAnimationFrame(animate);
    };
    animate();

    const handleResize = () => {
      width = canvas.width = window.innerWidth;
      height = canvas.height = window.innerHeight;
    };
    window.addEventListener("resize", handleResize);

    return () => {
      cancelAnimationFrame(animationFrameId);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return <canvas ref={canvasRef} className="canvas-bg" />;
};

/**
 * Главный компонент визитки AmyBlisso.
 */
const App = () => {
  // Три видеофайла
  const videos = [video1, video2, video3];

  // Случайно выбираем одно при загрузке
  const [videoIndex, setVideoIndex] = useState(
      Math.floor(Math.random() * videos.length)
  );

  // Кнопка для переключения (случайного) видео
  const handleChangeVideo = () => {
    if (videos.length < 2) return;
    let nextIndex = Math.floor(Math.random() * videos.length);
    while (nextIndex === videoIndex && videos.length > 1) {
      nextIndex = Math.floor(Math.random() * videos.length);
    }
    setVideoIndex(nextIndex);
  };

  return (
      <>
        {/* Слои фона: canvas, nebula, stars, moon */}
        <ParticleCanvas />
        <div className="nebula"></div>
        <div className="stars"></div>
        <div className="moon"></div>

        {/* Основной контейнер */}
        <div className="page-container">
          <div className="app-container">
            <div className="card-container fade-in">
              <div className="avatar-section">
                <div className="video-wrapper">
                  <video
                      src={videos[videoIndex]}
                      autoPlay
                      loop
                      muted
                      playsInline
                      className="video-avatar"
                  />
                  <div className="video-overlay"></div>
                </div>
                <div className="video-reflection"></div>

                <div className="title-section">
                  <h1 className="main-title">
                    AmyBlisso <span role="img" aria-label="stars">✨</span>
                  </h1>
                  <p className="subtitle">Warm Nocturnal Delights</p>
                </div>
              </div>

              <div className="intro-text fade-in" style={{ animationDelay: "0.5s" }}>
                <p>
                  Hi there! I'm <strong>AmyBlisso</strong>. Welcome to my cozy night world,
                  where gentle flickers of starlight spark your imagination.
                  Let my soothing glow show you the secrets of midnight bliss.
                </p>
              </div>

              <div className="link-buttons fade-in" style={{ animationDelay: "0.8s" }}>
                {/* Ссылки */}
                <a
                    href="https://onlyfans.com/amyblisso"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-btn main-link"
                >
                  OnlyFans
                </a>
                <a
                    href="https://x.com/AmyBlisso"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-btn"
                >
                  X (Twitter)
                </a>
                <a
                    href="https://www.instagram.com/amyblisso"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-btn"
                >
                  Instagram
                </a>
                <a
                    href="https://www.tiktok.com/@amyblisso"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-btn"
                >
                  TikTok
                </a>
              </div>

              <div className="extra-section fade-in" style={{ animationDelay: "1s" }}>
                <p>
                  Explore my private content under the mellow moonlight,
                  and let your fantasies linger in every radiant moment.
                  <br />
                  <em>Embrace the warm midnight aura &mdash; your dreams await!</em>
                </p>
              </div>

              {/* Кнопка "Change Video" */}
              <button onClick={handleChangeVideo} className="change-video-btn fade-in">
                Change Video
              </button>
            </div>
          </div>

          <div className="scroll-down">&#8595;</div>
        </div>
      </>
  );
};

export default App;
